﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class VehicleClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getAll() {
        return this.client.apiVehiclesGet();
    }
    get(vehicleAppId) {
        return this.client.apiVehiclesByIdGet(vehicleAppId);
    }
    getEditable() {
        return this.client.apiVehiclesEditableGet();
    }
    getByOrganization(organizationAppId) {
        return this.client.apiVehiclesOrganizationByOrganizationIdGet(organizationAppId);
    }
    create(vehicle) {
        return this.client.apiVehiclesPost(vehicle);
    }
    update(vehicleAppId, vehicle) {
        return this.client.apiVehiclesByIdPut(vehicleAppId, vehicle);
    }
    delete(vehicleAppIds) {
        return this.client.apiVehiclesDelete(vehicleAppIds);
    }
}
exports.VehicleClient = VehicleClient;
//# sourceMappingURL=VehicleClient.js.map